import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/hooks/useLanguage";
import { MAIN_SITE_URL } from "@/data/categories";

export default function Footer() {
  const { t } = useTranslation();
  const { currentLang } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-grid-fill text-base"></i>
            </span>
            <span className="text-base font-semibold font-heading text-background-50">
              {t("brand.name")}
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm text-background-200">
            {t("footer.tagline")}
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50">
            {t("footer.resources")}
          </h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <Link
                to={`/${currentLang}/basetao-spreadsheet`}
                className="text-background-200 transition hover:text-background-50"
              >
                {t("cta.readGuide")}
              </Link>
            </li>
            <li>
              <Link
                to={`/${currentLang}#categories`}
                className="text-background-200 transition hover:text-background-50"
              >
                {t("categories.title")}
              </Link>
            </li>
            <li>
              <Link
                to={`/${currentLang}#faq`}
                className="text-background-200 transition hover:text-background-50"
              >
                {t("faq.title")}
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50">
            {t("footer.legal")}
          </h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="text-background-200 transition hover:text-background-50"
              >
                {t("cta.visitMain")}
              </a>
            </li>
            <li>
              <span className="text-background-300">{t("brand.name")}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>
            © {year} {t("brand.name")}. {t("footer.rights")}
          </p>
          <p className="max-w-xl leading-relaxed">{t("footer.disclaimer")}</p>
        </div>
      </div>
    </footer>
  );
}